import React from 'react';
import './UXFeedbackInviteModal.css';

const UXFeedbackInviteModal = ({ isOpen, onClose, onAccept }) => {
    if (!isOpen) return null;

    return (
        <div className="ux-feedback-invite-modal-overlay" onClick={onClose}>
            <div className="ux-feedback-invite-modal" onClick={(e) => e.stopPropagation()}>
                <div className="ux-feedback-invite-modal-header" style={{ direction: "rtl", backgroundColor: "#4CAF50", borderRadius: "8px 8px 0 0" }}>
                    <h3 style={{ fontWeight: "bold", margin: 0 }}>נשמח לדקה מזמנך למילוי משוב!</h3>
                    <button className="ux-feedback-invite-modal-close" onClick={onClose}>×</button>
                </div>
                <div className="ux-feedback-invite-modal-body">
                    <p style={{ direction: "rtl", margin: "0 0 15px 0" }}>
                        היי! נשמח לשמוע את דעתך על המערכת.
                    </p>
                    <div className="ux-feedback-invite-button-group">
                        <button className="ux-feedback-invite-accept-button" onClick={onAccept}>
                            אשמח לתת משוב
                        </button>
                        <button className="ux-feedback-invite-decline-button" onClick={onClose}>
                            אולי בפעם אחרת
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UXFeedbackInviteModal; 